import { create } from 'zustand'

const init = {
  token: null,
  isReady: false
}

export const useAuthStore = create((set) => ({
  ...init,
  setIsReady: (isReady) => set({ isReady })
}))